/* eslint-disable react/no-array-index-key */
import { useTranslate } from 'hooks/useTranslate';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { store } from 'redux/store';
import errorSwal from 'utils/errorSwal';
import { isDocumentFileAllowed } from 'utils/isDocumentFileAllowed';

import sendContactEmail from 'modules/contact/api/contactActions';
import { getContactConfigByCorporateId } from 'modules/contact/utils/getContactConfigByCorporateId';

import 'assets/styles/Bootstrap.scss';
import './Contact.scss';

function Contact() {
  const { t } = useTranslate();

  const user = useSelector((state) => state.user);

  const [type, setType] = useState();
  const [category, setCategory] = useState();
  const [priority, setPriority] = useState();
  const [details, setDetails] = useState();
  const [message, setMessage] = useState();
  const [file, setFile] = useState();

  const {
    societyName,
    societyEmail,
    supportSource,
    supportFromName,
    supportFromEmail,
    showSupportTypeField,
    showCategoryField,
    showPriorityField,
    showAttachmentsField,
    hasWhiteBranding,
    emailTheme,
    disclaimers,
  } = getContactConfigByCorporateId();

  const contactTypes = {
    GENERAL: t('GeneralQuestion'),
    INCIDENCE: t('HaveIncidence'),
  };

  const ALLOWED_FILE_TYPES = 'application/pdf';

  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = async (event) => {
    const file = event.target.files[0];

    if (!isDocumentFileAllowed(file)) {
      errorSwal(t('InvalidFile'));
      return;
    }

    setFile(event.target.files[0]);
  };

  const handleReset = () => {
    setType('');
    setCategory('');
    setPriority('');
    setDetails('');
    setMessage('');
    setFile({});
  };

  function sendEmail(event) {
    event.preventDefault();

    const emailData = {
      societyName,
      societyEmail,
      type,
      category,
      priority,
      details,
      message,
      file,
      email: user.email,
      user: `${user?.name || ''}`.trim(),
      userId: user._id,
      source: supportSource,
      hasWhiteBranding,
      emailTheme,
    };

    if (supportFromName && supportFromEmail) {
      emailData.sender = {
        name: supportFromName,
        email: supportFromEmail,
      };
    }

    store.dispatch(sendContactEmail(emailData));
    handleReset();
    event.target.reset();
  }

  const isFormInvalid = () => {
    if (showSupportTypeField && !type) {
      return true;
    }

    if (showCategoryField && !category) {
      return true;
    }

    if (showPriorityField && !priority) {
      return true;
    }

    if (!details) {
      return true;
    }

    if (!message) {
      return true;
    }

    return false;
  };

  return (
    <div className="nk-content-body">
      <div className="nk-content-wrap">
        <div className="nk-block-head nk-block-head-lg">
          <div className="nk-block-head-sub">
            <a className="text-soft">
              <span>
                {t('ContactTo')} {societyName}
              </span>
            </a>
          </div>
          <div className="nk-block-head-content">
            <h2 className="nk-block-title fw-normal">{t('HowCanWeHelp')}</h2>
            <div className="nk-block-des">
              <p>{t('UseFollowingForm')}</p>
            </div>
          </div>
        </div>

        <div className="nk-block mb-3">
          <div className="card card-bordered">
            <div className="card-inner">
              <form className="form-contact is-alter" onSubmit={sendEmail}>
                <div className="row g-4">
                  {showSupportTypeField && (
                    <>
                      <div className="col-md-6">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name="type"
                            id="type-general"
                            value={contactTypes.GENERAL}
                            onChange={(event) => setType(event.target.value)}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="type-general"
                          >
                            {t('GeneralQuestion')}
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="custom-control custom-radio">
                          <input
                            type="radio"
                            className="custom-control-input"
                            name="type"
                            id="type-problem"
                            value={contactTypes.INCIDENCE}
                            onChange={(event) => setType(event.target.value)}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="type-problem"
                          >
                            {t('HaveIncidence')}
                          </label>
                        </div>
                      </div>
                    </>
                  )}

                  {showCategoryField && (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          <span>{t('Category')}</span>
                        </label>
                        <div className="form-control-wrap">
                          <select
                            className="form-control form-control-lg w-100"
                            data-search="off"
                            data-ui="lg"
                            onChange={(event) =>
                              setCategory(event.target.value)
                            }
                            defaultValue=""
                          >
                            <option hidden value="" className="text-success">
                              {t('SelectCategory')}
                            </option>
                            <option value="General">{t('General')}</option>
                            <option value="Facturación">{t('Billing')}</option>
                            <option value="Técnica">{t('Technical')}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  {showPriorityField && (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          <span>{t('Priority')}</span>
                        </label>
                        <div className="form-control-wrap">
                          <select
                            className="form-control form-control-lg w-100"
                            data-search="off"
                            data-ui="lg"
                            onChange={(event) =>
                              setPriority(event.target.value)
                            }
                            defaultValue=""
                          >
                            <option hidden value="">
                              {t('SelectPriority')}
                            </option>
                            <option value="Normal">{t('Normal')}</option>
                            <option value="Importante">{t('Important')}</option>
                            <option value="Urgente">{t('Urgent')}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label">
                        {t('DetailYourIssue')}
                      </label>
                      <div className="form-control-wrap">
                        <input
                          type="text"
                          className="form-control form-control-lg"
                          placeholder={`${t('DetailYourIssue')}...`}
                          value={details}
                          onChange={(event) => setDetails(event.target.value)}
                          defaultValue=""
                        />
                      </div>
                    </div>

                    {disclaimers?.issueDetails && (
                      <div className="d-block mt-3 fs-12px ff-italic">
                        <p className="text-soft">
                          {t(disclaimers.issueDetails)}
                        </p>
                      </div>
                    )}
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      <label className="form-label">
                        <span>{t('FacilitatesMoreInfo')}</span>
                        <em className="icon ni ni-info text-gray" />
                      </label>
                      <p className="text-soft">
                        {t('FacilitatesMoreInfoDetails')}
                      </p>
                      <div className="form-control-wrap">
                        <div className="form-editor-custom">
                          <textarea
                            className="form-control form-control-lg no-resize"
                            placeholder={t('WriteYourMessage')}
                            value={message}
                            onChange={(event) => setMessage(event.target.value)}
                            defaultValue=""
                          />
                          {showAttachmentsField && (
                            <div className="form-editor-action p-2">
                              <em className="icon ni ni-clip fs-18 ml-1" />
                              <input
                                id="customFile"
                                type="file"
                                accept={ALLOWED_FILE_TYPES}
                                ref={hiddenFileInput}
                                style={{ display: 'none' }}
                                onChange={handleChange}
                                defaultValue=""
                              />
                              <span
                                className="link collapsed cursor-pointer"
                                onClick={handleClick}
                              >
                                {file?.name || t('AttachFile')}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {disclaimers?.issueMoreInfo && (
                    <div className="d-block fs-12px ff-italic">
                      <p className="text-soft">
                        {t(disclaimers.issueMoreInfo)}
                      </p>
                    </div>
                  )}

                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-primary text-white"
                      disabled={isFormInvalid()}
                    >
                      {t('Send')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
